export default __webpack_public_path__ + "static/media/Slide15.9d964721.jpg";